import { isAppointmentsPage } from './location';
import { analytics } from 'src/services';

export const sendSegmentEvent = (message, metadata = {}, user) => {
  if (isAppointmentsPage()) {
    analytics.track(`${message} From VCA`, { ...metadata, email: user?.email });
  } else {
    analytics.track(`${message} From Aura`, {
      ...metadata,
      email: user?.email,
    });
  }
};
